"use strict";

import { DeviceDropdownModelProperties } from "./device-dropdown-model";

/**
* @ngdoc service
* @name nms.components.ui.device:DeviceDropdownModelService
* @description - Service para gerenciamento de modelos para a diretiva device-dropdown. Disponibiliza funções para criação do
* modelo a partir dos diferentes modelos de objeto utilizado nas diversas features (aplicação de template, dynamic device, summary
* e GPN ONUs e Manage Device). Utiliza o conceito de cache para armazenar os dados já obtidos de cada equipamento a fim de reduzir
* a necessidade de consultas no back-end.
* # DeviceDropdownModelService
* Factory in the nms.
*/
var app = angular.module("nms");

// TODO - [US-314] Verificar se esse service será reutilizado para CPE, caso não for, remover o TemplateInstanceIdentifierService.
// Caso for ser reutilizado, renomear as ocorrências de device para equipment

app.factory("DeviceDropdownModelService",
        ["DeviceDropdownModel", "ManagementDeviceRestService","TemplateInstanceIdentifierService",
    function(DeviceDropdownModel, ManagementDeviceRestService, TemplateInstanceIdentifierService) {
        /**
        * A utilização desta cache é necessária devido a ausência da informação de 'availableFeatures' que é utilizada na diretiva
        * para disponibilizar as features específicas e hoje é presente apenas no modelo de dados da Manage Device (front e
        * back-end). Se houver uma forma de incluir o atributo 'availableFeatures' no objeto de modelo de todas as features, o
        * modelo tratado por este service poderá ser sempre criado sem necessidade de nenhuma requisição REST ou cache.
        */
        var availableFeaturesCache: any = {};

        const service: any = {};

        service.createModelFromManagedDevice = function(managedDevice) {
            const model = new DeviceDropdownModel(managedDevice);
            availableFeaturesCache[managedDevice.id] = managedDevice.availableFeatures;
            return model;
        };

        service.createModelFromGponOnu = function(gponOnu) {
            const device: DeviceDropdownModelProperties = {
                id: gponOnu.deviceId,
                name: gponOnu.deviceName,
                hostname: gponOnu.deviceHostname,
                availableFeatures: service.getAvailableFeatures(gponOnu.deviceId)
            };
            return new DeviceDropdownModel(device);
        };

        service.createModelFromDeviceSearchModal = function(device) {
            return new DeviceDropdownModel(device);
        };

        service.createModelFromTemplateInstanceDevice = function(templateInstanceDevice) {
            const id = TemplateInstanceIdentifierService.resolveIdentifier(templateInstanceDevice.equipmentIdentifier);
            const device: DeviceDropdownModelProperties = {
                id,
                name: templateInstanceDevice.equipmentDetails.name,
                hostname: templateInstanceDevice.equipmentDetails.hostname,
                type: templateInstanceDevice.equipmentIdentifier.type,
                availableFeatures: checkForAvailableFeatures(templateInstanceDevice.equipmentIdentifier.type, id)
            };

            return new DeviceDropdownModel(device);
        };

        service.createModelFromTemplateApplicationResult = function(applicationResult) {
            const id = TemplateInstanceIdentifierService.resolveIdentifier(applicationResult.equipmentIdentifier);
            const device: DeviceDropdownModelProperties = {
                id,
                name: applicationResult.equipmentDetails.name,
                hostname: applicationResult.equipmentDetails.hostname,
                type: applicationResult.equipmentIdentifier.type,
                availableFeatures: checkForAvailableFeatures(applicationResult.equipmentIdentifier.type, id)
            };

            return new DeviceDropdownModel(device);
        };

        service.createModelFromVariableExtractionResult = function(extraction) {
            const id = TemplateInstanceIdentifierService.resolveIdentifier(extraction.equipmentIdentifier);
            const device: DeviceDropdownModelProperties = {
                id,
                name: extraction.equipmentDetails.name,
                hostname: extraction.equipmentDetails.hostname,
                availableFeatures: checkForAvailableFeatures(extraction.equipmentIdentifier.type, id)
            };

            return new DeviceDropdownModel(device);
        };

        function checkForAvailableFeatures(equipmentType, id) {
            return TemplateInstanceIdentifierService.isDeviceIdentifier(equipmentType)
                   ? service.getAvailableFeatures(id)
                   : [];
        }

        service.getAvailableFeatures = function(deviceId) {
            const cachedAvailableFeatures = availableFeaturesCache[deviceId];
            if (cachedAvailableFeatures) {
                return cachedAvailableFeatures;
            }

            return ManagementDeviceRestService.findDeviceById(deviceId).then(function(device) {
                const availableFeatures = device.availableFeatures;
                availableFeaturesCache[deviceId] = availableFeatures;
                return availableFeatures;
            });
        };

        return service;
    }
]);
